export const BASE_URL = process.env.REACT_APP_BACKEND_API;
export const LIMIT_PER_PAGE = 10;
